import { render } from "./dol-tree-select.vue?vue&type=template&id=24a3fb08"
import script from "./dol-tree-select.vue?vue&type=script&lang=js"
export * from "./dol-tree-select.vue?vue&type=script&lang=js"

import "./dol-tree-select.vue?vue&type=style&index=0&id=24a3fb08&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__